import React, { useEffect } from 'react';
import { Modal } from 'antd';
import classnames from 'classnames';
import styles from '../mailInfo.module.scss';
import IconCard from '@web-common/components/UI/IconCard/index';
import TaskSetting from './TaskSetting';
import TaskDesc from './TaskMailDesc';
import { MailActions, useAppSelector, useActions } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
import { remWaittingId } from '@web-mail-write/util';
const Task = props => {
    const infoStatus = useAppSelector(state => state.mailReducer.currentMail.status);
    const curAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const mailActions = useActions(MailActions);
    const taskShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.taskMailShow;
    const taskSetting = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.taskMailSetting;
    useEffect(() => {
        if (curAccount && !curAccount.isMainAccount && taskShow) {
            deleteConfConfirm();
        }
    }, [curAccount]);
    const deleteConfConfirm = () => {
        mailActions.doTaskShow(false);
        mailActions.doTaskMailSetting(false);
        mailActions.doReplaceReceiver([]);
    };
    const deleteTaskMail = e => {
        remWaittingId(currentMailId, true);
        e.stopPropagation();
        Modal.confirm({
            okButtonProps: { danger: true, type: 'default' },
            title: getIn18Text('QUEDINGSHANCHUREN'),
            okText: getIn18Text('SHANCHU'),
            cancelText: getIn18Text('QUXIAO'),
            onOk: deleteConfConfirm,
            width: 448,
            className: 'im-team',
            centered: true,
        });
    };
    const showSetting = () => {
        mailActions.doTaskMailSetting(true);
    };
    const set = taskShow ? (React.createElement("div", { className: classnames([styles.infoItem]), onClick: showSetting },
        React.createElement("span", { className: styles.infoLabel }, getIn18Text('SHIJIAN')),
        React.createElement("span", { className: styles.colonLabel }, ":"),
        React.createElement("div", { className: classnames([styles.conferenceTime, styles.conferenceTimeDesc]) },
            React.createElement(TaskDesc, null)),
        React.createElement("div", { className: classnames([styles.btnBox, styles.closeBtn]) },
            React.createElement("span", { className: classnames([styles.labelBtn, styles.labelCloseBtn]), onClick: deleteTaskMail },
                React.createElement(IconCard, { className: "dark-invert", type: "close" }))))) : null;
    return (React.createElement("div", { className: classnames([styles.guideCardWrapper]) },
        React.createElement("div", { className: classnames([styles.conferenceWrap]), style: { height: taskShow ? 'auto' : 0 } },
            React.createElement("div", { hidden: !taskSetting },
                React.createElement(TaskSetting, Object.assign({ deleteTaskMail: deleteTaskMail }, props))),
            React.createElement("div", { hidden: taskSetting }, set))));
};
export default Task;
